module.exports = __webpack_public_path__ + "static/media/walkthrough.11bfa058.mp4";